import { Applications as ApplicationsIcon } from "@volt_developers/react-ui-components";

import {
  ACTION_CREATE,
  ACTION_DETAILS,
  ACTION_LIST,
  ACTION_UPDATE,
} from "models/role/action";
import { SUBJECT_CLIENT } from "models/role/subject";
import { lazyRetry } from "utils/lazyRetry";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const ApplicationCreate = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "ApplicationManage" */
      "../pages/Create"
    ),
  "ApplicationManage"
);

const ApplicationDetails = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "ApplicationDetails" */
      "../pages/Details"
    ),
  "ApplicationDetails"
);

const ApplicationEdit = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "ApplicationManage" */
      "../pages/Edit"
    ),
  "ApplicationManage"
);

const ApplicationList = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "ApplicationList" */
      /* webpackPrefetch: true */
      "../pages/List"
    ),
  "ApplicationList"
);

export const applicationCreateRoute: Route = {
  path: "/configuration/applications/create",
  i18nName: "Application Create",
  component: ApplicationCreate,
  newTheme: true,
  can: {
    do: ACTION_CREATE,
    on: SUBJECT_CLIENT,
  },
};

export const applicationRoutes: Route = {
  can: {
    do: ACTION_LIST,
    on: SUBJECT_CLIENT,
  },
  children: [
    applicationCreateRoute,
    {
      path: "/configuration/applications/:id/edit",
      i18nName: "Application Edit",
      component: ApplicationEdit,
      newTheme: true,
      can: {
        do: ACTION_UPDATE,
        on: SUBJECT_CLIENT,
      },
    },
    {
      can: {
        do: ACTION_DETAILS,
        on: SUBJECT_CLIENT,
      },
      component: ApplicationDetails,
      hasNestedSwitch: true,
      i18nName: "Application",
      newTheme: true,
      path: PAGE_URLS.details,
    },
  ],
  component: ApplicationList,
  hasNestedSwitch: true,
  hidden: false,
  icon: ApplicationsIcon,
  i18nName: "Applications",
  newTheme: true,
  path: "/configuration/applications",
  showChildrenInSidebar: false,
};
